module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('request-status', {
    attrs: {
      "request": _vm.appointmentRequest,
      "message404": "Unable to load appointment. You may not have sufficient permissions to view this appointment"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.appointmentRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.loadAppointment
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (!_vm.editTitle) ? _c('v-toolbar-title', [(_vm.appointment.is_online) ? _c('v-icon', [_vm._v("headset_mic")]) : _vm._e(), _vm._v(" "), (_vm.appointment.title) ? _c('span', [_vm._v(_vm._s(_vm.appointment.title))]) : _c('span', [_vm._v(_vm._s(_vm.appointment.full_name))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.editTitle = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _c('v-text-field', {
    staticClass: "ml-0 mt-3",
    attrs: {
      "dense": "",
      "loading": _vm.editAppointmentRequest.loading,
      "append-icon": "save",
      "append-outer-icon": "cancel",
      "label": "Appointment title"
    },
    on: {
      "click:append": function($event) {
        return _vm.savetitle(_vm.appointment.title)
      },
      "click:append-outer": function($event) {
        _vm.editTitle = false
      }
    },
    model: {
      value: (_vm.appointment.title),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "title", $$v)
      },
      expression: "appointment.title"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.appointment.is_online) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n      Online\n    ")]) : _vm._e(), _vm._v(" "), (_vm.appointment.source && _vm.appointment.source.startsWith("online-booking")) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": "",
      "dark": "",
      "color": "success"
    }
  }, [_vm._v("\n      Booked online\n    ")]) : _vm._e(), _vm._v(" "), (_vm.appointment.status) ? _c('v-chip', {
    class: _vm.formatStatus(_vm.appointment.status).theme,
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formatStatus(_vm.appointment.status).title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('action-menu', {
    attrs: {
      "appointment": _vm.appointment,
      "exclude": ["open_appointment"]
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.appointment && _vm.appointment.id) ? [_c('flexible-component-container', {
    attrs: {
      "items": _vm.items,
      "isCompact": _vm.isCompact
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "caption pl-3"
  }, [_vm._v("\n    #" + _vm._s(_vm.appointment.id) + ".\n    Created: " + _vm._s(_vm.dateformat(_vm.appointment.created_date, 'ddd DD MMM YYYY \\at HH:mm')) + ".\n    Source: " + _vm._s(_vm.appointment.source) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d7559e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/AppointmentDetail.vue
// module id = 1453
// module chunks = 9